export const DEFAULT_SYSTEM_LANGUAGE = 'en';
export const ANALYTICS_CONSENT_KEY = 'analyticsConsent';